import axios from 'axios'
import store from 'store'
// import { notification } from 'ant-design-vue'

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Private-Network': true,
  },
  // timeout: 1000,
  // headers: { 'X-Custom-Header': 'foobar' }
})

apiClient.interceptors.request.use(request => {
  const accessToken = store.get('accessToken')
  if (accessToken) {
    request.headers.Authorization = `Bearer ${accessToken}`
    request.headers.AccessToken = accessToken
  }

  return request
})

apiClient.interceptors.response.use(response => {
  const xClientVersion = response.headers['x-client-version']
  console.info('xClientVersion:', xClientVersion)
  if (!xClientVersion) {
    return response
  }
  if (xClientVersion !== store.get('xClientVersion')) {
    console.log('New client version detected, reloading the app...')
    store.set('xClientVersion', xClientVersion)
    if (response.config.method === 'get') {
      console.log('Reloading the app to apply the new client version...')
      window.location.replace(window.location.href) // Reload the page to apply the new client version
    }
  }
  return response
})
// apiClient.interceptors.response.use(undefined, error => {
//   console.log('lucho', console.log(error.response.data))
//   // Errors handling
//   const { response } = error
//   const { data } = response
//   if (data) {
//     notification.warning({
//       message: data,
//     })
//   }
// })

export default apiClient
